import React, { forwardRef, useCallback } from "react";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/pro-light-svg-icons";
import { MenuBarProps } from "./Menu.types";
import { Routes } from "../../Routes";

import styles from "./MenuBar.module.css";

const MenuBar = forwardRef<HTMLDivElement, MenuBarProps>(({
  showMenu,
  setShowMenu,
}, ref)  => {
  const { t } = useTranslation();

  const handleMenuClick = useCallback(() => {
    setShowMenu((prev) => !prev);
  }, [setShowMenu]);

  const menuColorScheme = showMenu ?
    styles.expandedColors : styles.defaultColors;

  const menuExpandButtonClass = clsx({
    [styles.menuTitle]: true,
    [styles.expandedColors]: showMenu,
    [styles.defaultColors]: !showMenu,
  });

  const currentRoute = window.location.pathname;
  const isEducationPage = currentRoute.includes(Routes.Educations);

  const menuBarClass = clsx({
    [styles.menuBar]: true,
    [styles.menuBarNoBackdrop]: isEducationPage,
    [styles.menuBarLight]: showMenu,
  });

  return (
    <div className={menuBarClass}>
      <div ref={ref} className={styles.menuBarItem}>
        {!showMenu && (
          <div className={styles.menuLeftButton} onClick={handleMenuClick}>
            <FontAwesomeIcon
              icon={faBars}
              className={menuColorScheme}
              size="1x"
            />
            <p className={menuExpandButtonClass}>{t("menu.buttonTitle")}</p>
          </div>
        )}
      </div>
    </div>
  );
});

MenuBar.displayName = "MenuBar";

export { MenuBar };
